import { TRASHIE_GOOGLE_MAPS_API_KEY } from '../config/config';

// loading=async makes the loader non-render-blocking and silences Google's
// "loaded without async" console warning; libraries=places keeps the Places
// namespace available (the loader also awaits importLibrary('places')).
const script = `https://maps.googleapis.com/maps/api/js?key=${TRASHIE_GOOGLE_MAPS_API_KEY}&libraries=places&loading=async`;

export default script;
